// extracted by mini-css-extract-plugin
module.exports = {"container":"Reason_container__h1Q0b","text":"Reason_text__LSDaW"};